<template>
  <nav class="navbar navbar-expand-lg navbar-white fixed-top shadow">
    <div class="container-fluid">
      <router-link class="navbar-brand ms-md-5" to="/" style="text-align: center">
        <div style="max-width: 60px; max-height: 60px">
          <img :src="this.logo" alt="Logo" class="img-fluid" style="background-size: fit-content; width: 100%" />
        </div>
      </router-link>
      <div class="collapse navbar-collapse" :class="{ 'mobile-menu': isMobile }" id="navbarNav">
        <ul class="navbar-nav">
          <li v-for="(item, index) in isMobile ? mobile : menus" :key="index" class="nav-item">
            <router-link :to="redirect(item)" class="nav-link" active-class="active active-color">
              {{ item.name }} <span class="sr-only">(current)</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div v-if="$route.name !== 'search-page'" class="search-area d-none d-sm-block mr-1">
        <input type="text" v-model="searchQuery" @keyup.enter="handleSearch"
          :style="{ borderColor: isEmptySearch ? 'red' : '' }" class="search-box" />
      </div>

      <!-- Hamburger menu for mobile screen -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" @click="toggleNavbar" style="
          position: fixed;
          top: 0;
          right: 0;
          margin-top: 5px;
          margin-right: 3px;
        ">
        <img :src="menuIconSrc" class="menu-icon" id="menu-icon" />
      </button>

      <!-- Menu button for fries menu, hidden in md, sm screen size -->
      <div class="d-none d-lg-block">
        <button data-bs-toggle="modal" data-bs-target="#manageRoleModal">
          <img :src="menuIconSrc" class="menu-icon" />
        </button>
      </div>
    </div>
  </nav>

  <div class="modal fade" id="manageRoleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenter"
    aria-hidden="true">
    <div class="modal-dialog modal-fullscreen modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="top-right row col-xs-4 pull-right" style="width: 270px">
            <div>
              <a href="/search" class="m-r-20 font-black" @click="clearLocalStorage">
                <i class="fa fa-search nav-fries"><span class="pl-2"
                    style="font-family: 'SpeedeeRegular', sans-serif">Search</span></i>
              </a>
            </div>
            <div>
              <a href="/contact" class="m-r-20 font-black">
                <i class="fa fa-map-marker nav-fries"><span class="pl-2"
                    style="font-family: 'SpeedeeRegular', sans-serif">Find Restaurant</span></i>
              </a>
            </div>
            <div>
              <button class="btn-close f-right nav-fries" type="button" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
          </div>
          <svg class="fries img-fluid" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 2665.38 1972">
            <defs>
              <clipPath id="clip-path">
                <rect id="clip" width="2665.38" height="1972" fill="none"></rect>
              </clipPath>
            </defs>
            <g clip-path="url(#clip-path)">
              <path class="fry-11"
                d="M-814.26,2320-862,2116.24c-7.67-17.25,2867-221.74,3031.84-239,13.41,103.49-115,295.14-134.16,297.05C1884.3,2191.55-660.95,2318-814.26,2320Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-10"
                d="M-856,2147.47c268.3-174,2780.59-565.35,3077.64-619,17.25-3.83,139.9,141.82,153.32,245.3C2141.11,1812.09-526.22,2434-744.69,2499.14Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-9"
                d="M-967.58,1945.67c266.39-69,2876.8-695.1,3041.61-725.76,32.58,97.74-11.5,276-49.83,283.63-184,38.33-2570.54,777.51-2796.68,859.92Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-8"
                d="M-814.26,1875.34c210.81-78.58,2970.51-1031.82,3189.18-1097,44.08,67.07-19.17,276-57.5,287.46C1886.22,1200-383.25,2056.25-661.14,2171.24Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-7"
                d="M-591.57,1823.78s2019-967.62,2587.22-1272.72c34.5-19.16,182.06,76.66,235.72,166.74C2064.64,813.62-194.86,2081.93-361.59,2172Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-6"
                d="M-1002.46,1820.53C-989,1809,1718.91,386.25,1685,397.75c36.41,82.41,38.33,185.89,26.83,228.06C1545.09,738.88-600.77,2120.64-765.58,2248.47-765.58,2248.47-1063.79,1874.19-1002.46,1820.53Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-5"
                d="M-1110.55,1597.26s1946-992.15,2514-1297.06c34.5-19.16,182.07,76.66,235.73,166.73C1472.46,562.75-787.24,1830.88-954,1921Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-4"
                d="M-1385.18,1219.91C-1134.12,1124.09,1581.5,131.36,1846,45.12c40.25,124.57,32.58,258.72-32.58,308.55C1778.9,365.17-1212.89,1517-1247.38,1528.46-1211,1610.87-1262.52,1156.67-1385.18,1219.91Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-3"
                d="M-1301.62,1326.08C-1074.71,1222.59,1294-69.87,1502.93-205.94c59.41,86.24,95.82,214.65,42.16,281.72-115,74.74-2501.36,1652.56-2624,1715.81Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-2"
                d="M-1301.62,1416.54s2496-1779.63,2444.25-1739.38c63.25,23,118.82,88.16,162.9,166.73C1106.22-44.95-931,1548-1120.7,1691.74-1185.86,1673.34-1295.87,1434.55-1301.62,1416.54Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="fry-1"
                d="M-1134.5,1691.55l-167.12-275C-1100.39,1242.91,979.73-529.82,1200.13-692.72c67.07,78.58,105.4,241.48,74.74,266.39C1221.21-386.08-1128.75,1708.8-1134.5,1691.55Z"
                fill="#ffbc0d" style="
                  transform: translateX(0px) translateY(0px);
                  animation: bounceIn 2s alternate;
                "></path>
              <path class="box"
                d="M-971.22,2691.75c-13.42-247.22-32.58-425.46-166.73-741.67s-247.23-454.2-415.87-636.27l61.32-203.14c689.93-563.44,1744-1211.2,1964.37-1345.35L602.19,72C479.54,188.85,13.84,692.88,289.81,1344.48s962.06,668.84,1130.71,661.18l130.32,306.63C1301.7,2377.45,102,2684.08-783.41,2785.65Z"
                fill="#db0007"></path>
              <path class="logo"
                d="M-37.9,1227.57c38.32,88.16-47.92,216.56-208.9,346.88,207-24.91,358.38,1.92,394.79,92,65.16,155.24-274,448.45-757,653.52l-53.66-124.57c450.37-189.73,783.83-414,747.42-502.12s-402.46-13.41-818.33,161l-53.66-124.57c415.87-176.32,722.5-387.13,686.09-475.29s-431.2-1.91-879.65,187.82l-53.66-124.57C-549.6,1112.59-105,1072.34-37.9,1227.57Z"
                fill="#ffbc0d"></path>
              <path class="mask"
                d="M1506.76,1944.33a41.38,41.38,0,0,0-42.16-24.91c-80.49,5.75-803,42.16-1077-609.44S638.6,165.86,699.93,112.2a44.28,44.28,0,0,0,11.5-47.92L558.11-292.37l-87,57.49L601.43,71.76C478.77,188.66,13.07,692.69,289,1344.29s962.07,668.84,1130.71,661.17l130.32,306.64c-139.71,36.6,102.72-25.49,102.72-25.49Z"
                fill="#fff"></path>
            </g>
          </svg>

          <div class="fries-menu-list d-flex">
            <div class="col-lg-12 d-flex">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <ul>
                  <li v-for="(item, index) in friesMenu" :key="index" class="nav-item" data-bs-dismiss="modal">
                    <router-link :to="redirect(item)" class="nav-fries" active-class="active active-color">
                      {{ item.name }} <span class="sr-only">(current)</span>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center align-items-end">
                <div>
                  <a href="/promotion">
                    <div class="d-flex align-items-end gap-3">
                      <!-- <img src="@/assets/images/fries-menu/Promotion.svg" alt="" class="img-fluid" width="100" /> -->
                      <img :src="this.icon" alt="" class="img-fluid" width="100" />
                      <h5 class="fw-bold nav-fries">Promotions</h5>
                    </div>
                    <div class="d-flex justify-content-center offer">
                      <h5 class="fw-bold nav-fries">Check our offer</h5>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleMixin from "@/mixins/TitleMixins.js";
import axios from "axios";

export default {
  name: "TopHeader",
  mixins: [titleMixin],

  data() {
    return {
      menuIconSrc: require("@/assets/icons/Menu.svg"),
      scrolled: false,
      showTopBar: true,
      searchQuery: "",
      isEmptySearch: false,
      menus: [],
      friesMenu: [],
      mobile: [],
      isMobile: false,
      logo: [],
    };
  },

  methods: {
    redirect(item) {
      let redirectTo = "";

      if (item.slug == "home-view") {
        redirectTo = "/";
      } else if (item.path == null) {
        redirectTo = "#";
      } else {
        redirectTo = item.path;
      }

      return redirectTo;
    },

    isCurrentPage(item) {
      // Check if the current route matches the item's route
      return this.redirect(item) == this.currentRouteName;
    },

    handleSearch() {
      if (this.searchQuery.trim() === "") {
        this.isEmptySearch = true;
        return;
      }

      localStorage.setItem("search", this.searchQuery);

      this.$router.push({
        name: "search-page",
        query: { search: this.searchQuery },
      });
    },

    handleScroll() {
      this.scrolled = window.scrollY > 0;
      this.menuIconSrc = this.scrolled
        ? require("@/assets/icons/Menu-White.svg")
        : require("@/assets/icons/Menu.svg");
    },

    toggleNavbar() {
      document.getElementById("navbarNav").classList.toggle("show");
    },

    handleResize() {
      this.isMobile = window.innerWidth < 850;
    },

    clearLocalStorage() {
      localStorage.removeItem("search");
    },
  },

  mounted() {
    axios.get("/headers/1/view").then((response) => {
      this.menus = response.data.data.menus;
      this.logo = response.data.data.image_url;
    });

    axios.get("/headers/2/view").then((response) => {
      this.friesMenu = response.data.data.menus;
      this.icon = response.data.data.image_url;
    });

    axios.get("/headers/3/view").then((response) => {
      this.mobile = response.data.data.menus;
      this.isMobile = window.innerWidth < 850;
    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);

    document
      .getElementById("btnTop")
      .addEventListener("click", this.scrollToTop);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
};

window.addEventListener("scroll", function () {
  var navbar = document.querySelector(".navbar");
  var navbarNav = document.querySelector("#navbarNav");
  var scrolled = window.scrollY;

  if (navbar) {
    if (scrolled > 0) {
      navbarNav.classList.add("scrolled");
      navbar.classList.add("scrolled");
    } else {
      navbar.classList.remove("scrolled");
      navbarNav.classList.remove("scrolled");
    }
  }
});
</script>

<style scoped>
#navbarNav {
  font-size: 20px;
  font-weight: bold;
  color: black;
  background-color: white;
  transition: background-color 0.3s ease-in-out;
}

.navbar {
  background-color: white;
  transition: background-color 0.3s ease-in-out;
  height: 85px;
}

.scrolled {
  background-color: #ffbc0d !important;
}

.nav-link {
  color: black;
  margin: 0 10px;
}

.nav-link:hover,
.nav-fries:hover {
  color: #db0007;
}

.active-color {
  color: #db0007 !important;
}

.search-box {
  border: 1px solid grey;
  border-radius: 50px;
  padding: 7px;
  margin: 0 30px;
  background: white url("@/assets/icons/search-icon.png") no-repeat right 15px center;
  background-size: 15px 15px;
}

.search-box:focus {
  border: 2px solid black;
}

.error-border {
  border: 1px solid red;
}

.menu-icon {
  height: 60px;
  width: 40px;
}

.fries {
  width: 59%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.fries .fry-11,
.fry-10,
.fry-9,
.fry-8,
.fry-7,
.fry-6,
.fry-5,
.fry-4,
.fry-3,
.fry-2,
.fry-1 {
  animation: bounceIn 2s alternate;
}

.top-right {
  font-family: "SpeedeeRegular", sans-serif !important;

  padding: 0;
  margin: 22px 0 0;
  width: auto !important;
  max-width: 360px;
  z-index: 3;
}

.fries-menu-list {
  transform: translate(13rem);
  font-size: 5rem;
  font-weight: bolder;
  width: 85%;
}

.fries-menu-list a {
  text-decoration: none;
  color: black;
}

.offer {
  background-image: url(@/assets/images/fries-menu/Line.svg);
  background-size: contain;
  background-position: bottom;
  padding: 40px;
}

@media only screen and (min-width: 1200px) and (max-width: 1600px) {
  .top-right {
    transform: translate(0);
  }

  .fries {
    transform: translate(0, 5rem);
  }

  .fries-menu-list {
    font-size: 4rem;
    transform: translate(10rem, 5rem);
  }
}

@media only screen and (max-width: 1200px) {
  .fries {
    transform: translate(0, 5rem);
  }

  .fries-menu-list {
    font-size: 3rem;
    transform: translate(6rem, 3rem);
  }
}

@media only screen and (max-width: 1060px) {
  .navbar-nav .nav-item .nav-link {
    font-size: 13px;
  }
}

@media only screen and (max-width: 992px) {
  .search-box {
    margin: 0 80px !important;
  }
}
</style>